import React from "react";
import ReactApexChart from "react-apexcharts";

class ProjectAchievementChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: "نسبة الإنجاز",
          data: [],
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "60%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}%`,
          style: {
            fontSize: "12px",
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: "رمز المشروع",
            style: {
              fontSize: "14px",
              fontFamily: "Cairo",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => `${val}%`,
          },
          max: 100,
        },
        colors: ["#28a745"],
        tooltip: {
          y: {
            formatter: (val) => `${val}%`,
          },
        },
      },
    };
  }

  async componentDidMount() {
    try {
      const response = await fetch("https://promaster.areez.co/api/projects/compare_achievements",
        {
              
        headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json"
          },
        }
      );
      const data = await response.json();

      const codes = data.map((item) => item.code);
      const percentages = data.map((item) =>
        parseFloat(item.achievement_percentage.toFixed(2))
      );

      this.setState({
        series: [
          {
            name: "نسبة الإنجاز",
            data: percentages,
          },
        ],
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: codes,
          },
        },
      });
    } catch (err) {
      console.error("خطأ أثناء تحميل بيانات المشاريع:", err);
    }
  }

  render() {
    return (
      <div className="card mt-4 p-3">
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={350}
        />
      </div>
    );
  }
}

export default ProjectAchievementChart;
